import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { TaskListQuery, TaskUserListQuery } from '../../../api/endpoints/tasks';
import { useAppEvent } from '../../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../../Container';

export const useTaskQuery = (inputs: TaskListQuery) => {
    const api = useResolve(ApiClient);
    const qc = useQueryClient();

    useAppEvent('tasks:changed', () => {
        qc.invalidateQueries(['tasks.list']);
    });

    return useQuery({
        queryKey: ['tasks.list', JSON.stringify(inputs)],
        queryFn: async () => {
            return await api.exec(v2.tasks.list(inputs));
        },
    });
};

export const useTaskUserQuery = (inputs: TaskUserListQuery) => {
    const api = useResolve(ApiClient);
    const qc = useQueryClient();

    useAppEvent('tasks:changed', () => {
        qc.invalidateQueries(['tasks.users.list']);
    });

    return useQuery({
        queryKey: ['tasks.users.list', JSON.stringify(inputs)],
        queryFn: async () => await api.exec(v2.tasks.users.list(inputs)),
    });
};
